import { apiRequest, investmentEntityRequest } from '@utils/request';
import { DocumentAcknowledgmentsResponse, DocumentClientAgreementResponse } from 'types/documents';

export const getFundriseDocumentsAndAgreements = async (
	orderGroupId: string
): Promise<DocumentAcknowledgmentsResponse> => {
	const response = await investmentEntityRequest.get(`/investment/order-group/${orderGroupId}/acknowledgments`);
	const data = response.data as DocumentAcknowledgmentsResponse;
	return {
		reitDocuments: data.reitDocuments,
		acknowledgments: data.acknowledgments,
		miscDocuments: data.miscDocuments,
		advisoryDocuments: data.advisoryDocuments,
		reviewOrderAcknowledgements: data.reviewOrderAcknowledgements,
		reviewOrderDisclaimer: data.reviewOrderDisclaimer
	};
};

export const getFundriseClientAgreementDocuments = async (): Promise<DocumentClientAgreementResponse> => {
	const response = await apiRequest.get(`/website-documents/terms-of-service-privacy-policy`);

	return {
		privacyPolicy: {
			documentRevisionId: response.data.privacyPolicy.documentRevisionId,
			title: response.data.privacyPolicy.title,
			url: response.data.privacyPolicy.url
		},
		termsOfService: {
			documentRevisionId: response.data.termsOfService.documentRevisionId,
			title: response.data.termsOfService.title,
			url: response.data.termsOfService.url
		},
		clientAgreement: {
			documentRevisionId: response.data.fundriseClientAgreement.documentRevisionId,
			title: 'Client Agreement',
			url: response.data.fundriseClientAgreement.url
		},
		formAdvPart2: {
			documentRevisionId: response.data.formAdvPart2.documentRevisionId,
			title: 'Form ADV Part II',
			url: response.data.formAdvPart2.url
		},
		formCrs: {
			documentRevisionId: response.data.formCrs.documentRevisionId,
			title: 'Form CRS',
			url: response.data.formCrs.url
		}
	};
};
